import React, { useState, useEffect } from "react";
import dragon from "../assets/Dragon_and_Boy.webp";

const AboutUs = () => {
  const [showMore, setShowMore] = useState(false);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobileOrTablet(window.innerWidth < 1024); // Tailwind's lg breakpoint
    };
    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return (
    <>
      <section
        id="aboutus"
        className="py-8 md:py-12 flex justify-center items-center bg-[#090522] p-4 md:p-8"
      >
        <div className="max-w-6xl bg-[#090522] border-2 border-yellow-500 rounded-3xl p-4 md:p-8 flex flex-col md:flex-row items-center md:items-start gap-4 md:gap-8">
          <div className="flex-1 text-white">
            <h2 className="text-2xl md:text-4xl font-extrabold mb-3 md:mb-4">
              <span className="text-orange-500">Hey, Wanna Know</span>{" "}
              <span className="text-yellow-400">who we are</span>
            </h2>

            <p className="text-md mb-3 md:mb-4">
              At Haptic Realities, we began our journey as a creative production
              company, delivering high-quality content across films,
              advertising, and digital platforms. As we grew, we noticed a clear
              gap between what the multimedia industry needed and what
              traditional training institutes were offering.
            </p>

            {/* Hidden on mobile/tablet unless expanded */}
            <div
              className={`${
                isMobileOrTablet && !showMore ? "hidden" : ""
              } lg:block`}
            >
              <p className="text-md mb-3 md:mb-4">
                To bridge this gap, we launched skill-based multimedia training,
                focused on preparing students for real-world production
                environments. Our courses are designed by professionals, for
                professionals—ensuring that learners not only master tools like
                VFX, 3D, graphic design, and video editing, but also gain the
                production mindset needed to succeed in the industry.
              </p>
              <p className="text-md mb-3 md:mb-4">
                We've proudly delivered advanced skill training at premier
                institutions like the National Institute of Fashion Technology
                (NIFT), and continue to shape creative minds ready for the job
                market.
              </p>
              <p className="text-md">
                Today, we stand strong both as a production studio and a
                training institute, committed to empowering the next generation
                of visual storytellers.
              </p>
            </div>

            {/* Read More / Show Less Button for mobile/tablet only */}
            {isMobileOrTablet && (
              <button
                onClick={() => setShowMore(!showMore)}
                className="text-yellow-400 font-semibold mt-2"
              >
                {showMore ? "Show Less" : "Read More"}
              </button>
            )}
          </div>
          <div className="flex-shrink-0 md:mt-16 lg:mt-28">
            <img
              src={dragon}
              alt="Animated Boy and Dragon"
              width={200}
              height={200}
              className="rounded-2xl w-[300px] md:w-[350px]"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
